import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db, ensureAnonymousUser, isFirebaseConfigured } from './firebase';
import type { OrderFormValues, ServiceModel, ServiceTier } from '../types/portfolio';

export type PendingOrderRecord = {
  id: string;
  savedTo: 'firebase' | 'local-demo';
};

function localOrderId() {
  return `ORD-${Date.now().toString(36).toUpperCase()}`;
}

export async function createPendingOrder(
  values: OrderFormValues,
  files: File[],
  tier: ServiceTier,
  model: ServiceModel,
): Promise<PendingOrderRecord> {
  if (!isFirebaseConfigured || !db) {
    const id = localOrderId();
    const existing = JSON.parse(localStorage.getItem('portfolio-demo-pending-orders') || '[]') as unknown[];
    localStorage.setItem(
      'portfolio-demo-pending-orders',
      JSON.stringify([
        {
          id,
          ...values,
          serviceTier: tier.name,
          selectedModel: model.name,
          selectedPrice: model.price,
          files: files.map((file) => file.name),
          status: 'awaiting_payment',
          createdAt: new Date().toISOString(),
        },
        ...existing,
      ]),
    );
    return { id, savedTo: 'local-demo' };
  }

  const user = await ensureAnonymousUser();
  if (!user) throw new Error('Authentication is not available.');

  const orderRef = await addDoc(collection(db, 'orders'), {
    uid: user.uid,
    name: values.name.trim(),
    email: values.email.trim(),
    handle: values.handle.trim(),
    workType: tier.name,
    category: `${tier.name} / ${model.name}`,
    budget: model.price,
    deadline: values.deadline,
    description: values.description.trim(),
    priority: values.priority,
    features: values.features,
    serviceTierId: tier.id,
    serviceTier: tier.name,
    selectedModelId: model.id,
    selectedModel: model.name,
    selectedModelNote: model.note,
    selectedPrice: model.price,
    selectedModelFeatures: model.features,
    fileNames: files.map((file) => file.name),
    status: 'awaiting_payment',
    paymentStatus: 'pending',
    emailStatus: 'not_sent',
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  return { id: orderRef.id, savedTo: 'firebase' };
}
